<div class="wrapper">
  <div class="parent">
    <div class="user-tasks-pane">
      <div class="valuation-event-title">
        <h3>
          {{'raci.userDashboardHost.userTasks' | translate}}
        </h3>
      </div>
      <h3 class="noApprovalMessage" *ngIf="approvalTasks?.length < 1">
        {{'raci.portfolioProperties.noApprovalTasks' | translate}}
      </h3>
      <user-tasks-pane [tasks]="userTasks"
                       [refresh]="refreshUserTasksList"
                       (onChangeUserActiveTask)="setActiveUserTask($event)"
                       (onCompleteTask)="onCompleteTask($event)"
                       (approvalMatrixOfTask)="setApprovalMatrix($event)"
                       (setValuationSetupTask)="setValuationSetupTask()"
                       (approvalMatrixOfFunctionTask)="setApprovalMatrixOfFunctionTask($event)"
                       (generalTaskApprovalMatrix)="setGeneralTaskApprovalMatrix($event)"></user-tasks-pane>
    </div>
    <div class="approval-matrix">
      <approval-matrix [groupBy]="groupBy"
                       [approvalMatrix]="approvalMatrixOfTask"
                       [hideApprovalMatrix]="hideApprovalMatrix"
                       [currentUser]="currentUser"
                       (updateUserDashboardCompleteTaskStatus)="setUserDashboardCompleteTaskStatus($event)"
                       *ngIf="(activeTask?.taskTypeId == taskTypes.Approval || activeTask?.taskTypeId == taskTypes.Undefined) && approvalMatrixOfTask"></approval-matrix>

      <general-tasks-approval-matrix [generalTaskApprovalMatrix]="generalTaskApprovalMatrix"
                                     [groupBy]="groupBy"
                                     [currentUser]="currentUser"
                                     (updateSelectedGeneralTaskProperty)="updateSelectedGeneralTaskProperty($event)"
                                     *ngIf="generalTaskApprovalMatrix && activeTask?.taskTypeId != taskTypes.ValoremFunction && activeTask?.taskTypeId != taskTypes.ArgusFunction && activeTask?.taskTypeId != taskTypes.ArgusSyncFunction"></general-tasks-approval-matrix>

      <valorem-approval-matrix *ngIf="activeTask?.taskTypeId == taskTypes.ValoremFunction"
                               [data]="approvalMatrixOfFunctionTask"
                               [showTitleInfo]="true"
                               [groupBy]="groupBy"
                               [currentTask]="activeTask"
                               [publishInformation]="activeTask?.valoremPublishInformation"
                               [allowApproving]="allowApproving"></valorem-approval-matrix>
      <argus-approval-matrix *ngIf="activeTask?.taskTypeId == taskTypes.ArgusFunction"
                             [data]="approvalMatrixOfFunctionTask"
                             [currentUser]="currentUser"
                             [showTitleInfo]="true"
                             [groupBy]="groupBy"
                             [allowSync]="allowApproving"
                             [currentTask]="activeTask"
                             (onSyncWithArgus)="syncWithArgus($event)"></argus-approval-matrix>
      <argus-push-matrix *ngIf="activeTask?.taskTypeId == taskTypes.ArgusSyncFunction"
                         [data]="approvalMatrixOfFunctionTask"
                         [showTitleInfo]="true"
                         [currentUser]="currentUser"
                         [lastSyncInfo]="argusLastSyncInfo"
                         [numberOfSyncProp]="argusNumberOfSyncProp"
                         [groupBy]="groupBy"
                         [allowSync]="true"
                         [currentTask]="activeTask"></argus-push-matrix>
      <valuation-event-setup-form *ngIf="activeTask?.taskTypeId == taskTypes.ValuationEventFunction"
                                  [portfolioId]="activeTask.portfolioId"
                                  [showTitleInfo]="true">
      </valuation-event-setup-form>
      <close-valuation-event *ngIf="activeTask?.taskTypeId == taskTypes.CloseValuationEvent"
                             (selectedCloseOption)="onSelectedCloseOption($event)"
                             (selectedCopyPropertiesOption)="onSelectedCopyPropertiesOption($event)"
                             (selectedFxTablesOption)="onSelectedFxTablesOption($event)"
                             (newValuationName)="onNewValuationName($event)"
                             (newValuationDate)="onNewValuationDate($event)"
                             [portfolioId]="activeTask?.portfolioId"
                             [projectId]="activeTask?.projectId"
                             [showTitleInfo]="true"
                             [currentTask]="activeTask">
      </close-valuation-event>
      <valuation-effective-dates-setup *ngIf="activeTask?.taskTypeId == taskTypes.ValuationEffectiveDatesSetup"
                                       [showTitleInfo]="true"
                                       [projectId]="activeTask?.projectId"
                                       [disableFunctions]="!(!activeTask?.isCompleted)"
                                       [selectedValuationEventId]="activeTask.portfolioId"></valuation-effective-dates-setup>
    </div>
    <div class="project-details" *ngIf="isProjectDetailsDisplayed">
      <project-details [selectedGeneralTaskProperty]="selectedGeneralTaskProperty"></project-details>
    </div>
    <div class="approval-history" *ngIf="isApprovalHistoryDisplayed">
      <approval-history *ngIf="userDashboardActiveTask"
                        [activeTask]="activeTask"
                        [generalTaskHistory]="generalTasksApprovalHistory">
      </approval-history>
    </div>
    <div class="approval-history" *ngIf="shouldShowTaskApprovalHistory">
      <approval-history *ngIf="activeTask"
                        [activeTask]="activeTask">
      </approval-history>
    </div>
  </div>
</div>
<data-loader></data-loader>
<div class="k-overlay" *ngIf="showGetDataFromArgusDialog || isSyncWithArgusDisplayed || isPublishToValoremDisplayed || showCloseValuationEventDialog"></div>
<data-from-argus-dialog *ngIf="showGetDataFromArgusDialog"
                        [canClose]="true"
                        [properties]="properties"
                        (closePane)="closeAllPanes()"
                        (sholudContinueWithArgus)="continueWithArgus()">
</data-from-argus-dialog>
<report-argus-sync-dialog *ngIf="isSyncWithArgusDisplayed"
                          [canClose]="true"
                          [reportIds]="selectedReportIds"
                          (closePane)="closeAllPanes()">
</report-argus-sync-dialog>
<valorem-publish-task *ngIf="isPublishToValoremDisplayed"
                      [valuationEventId]="activeTask?.taskValuationPortfolioId"
                      (onPublishInformationChange)="onPublishInformationChange($event)">
</valorem-publish-task>
<close-valuation-event-dialog *ngIf="showCloseValuationEventDialog"
                              [portfolio] ="activePortfolio"
                              [dialogMessage]="closeValEventDialogMessage"
                              [canClose]="true"
                              [optionSelected]="closeValEventOptionSelected"
                              [copyProperties]="copyProperties"
                              [copyFxTables]="copyFxTables"
                              [valuationDate]="newValuationDate"
                              [valuationName]="newValuationName"
                              (onCloseProject)="onCloseProject()">
</close-valuation-event-dialog>
